import { commonFilter } from './filter';

export default {
  pageName: 'Compare-DifferentDate',
  pageId: '25020',
  pagePath: '/opinion/Compare',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
    ClickOneMetricsSet: {
      buttonId: '25010102',
    },
    EditMetrics: {
      buttonId: '25010103',
    },
    ConfirmEditedMetrics: {
      buttonId: '25010104',
    },
    ChooseGame: {
      buttonId: '25010105',
    },
    SplitMetrics: {
      buttonId: '25010107',
    },
    Rank: {
      buttonId: '25010108',
    },
    Locate: {
      buttonId: '25010109',
    },
    DeleteGame: {
      buttonId: '25010110',
    },
  },
  card: {
    'Game Comparison Table': {
      download: {
        buttonId: '25010111',
      },
    },
    'Comparison Chart': {
      line: {
        buttonId: '25010112',
      },
      bar: {
        buttonId: '25010113',
      },
      download: {
        buttonId: '25010114',
      },
    },
  },
};
